import React, { useState } from "react";
import { Button, Modal, ModalBody } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import {
  deleteQuestionOpen,
  deleteSearchSuggestionRecord,
  getSearchSuggestionsCount,
  getSearchSuggestionsForCMRecords,
  AtomizerJobAPI
} from "../../../API/api";
import { Actions } from "../../../Action";
import styles from "./DeleteQuestionModalStyles.css";
import { handleError } from "../../../utils";
import { updateOpenTabData } from "../../../Action/actions";
import { toast } from "react-toastify";
import { CURRENT_ROLE } from "../../../API/url";
import VizButton from "../../VizButtons/VizButton";
import VizParagraph from "../../VizParagraph/VizParagraph";
import DeleteIcon from "@mui/icons-material/Delete";

const onSuccessfulQuestionDelete = (message) => {
  return (
    <>
      {/* <p style={{ fontSize: "13px", fontWeight: "bold" }}>Success!</p> */}
      <span style={{ fontSize: "11px" }}>{message}</span>
    </>
  );
};

const modalTitleStyle = {
  color: "rgb(42, 54, 74)",
  fontSize: "20px",
  fontFamily: "Helvetica",
};

const textStyles1 = {
  fontSize: "16px",
  color: "#2A364A",
  lineHeight: "24px",
  fontWeight: "500",
  wordBreak: 'break-word', overflowWrap: 'break-word',
  textAlign: "left",
  display: "flex",
  justifyContent: "center",
  width: "100%"


};
export default function OverwriteModal() {
  const dispatch = useDispatch();
  const { advanceFilterModalToggle, ingestedrefreshData } = bindActionCreators(Actions, dispatch);
  const modalState = useSelector((state) => state.domain);
  const IngestedState = useSelector((state) => state.drawer);
  const [isLoading,setLoading]=useState(false)
  const onClickDeleteDataConfirm = () => {
    setLoading(true)
    advanceFilterModalToggle({ bool: false, value: "" });
	const payload = {
		action: "overwrite",
		data: [
			{
				oldSoId: IngestedState.tableDataCurrent.soId,
				soId: IngestedState.tableDataCurrent.newSoId,
				jobId: "",
				mapDocs: false
			}
		]
	}
	AtomizerJobAPI(payload).then(res=>{
    if (res===undefined) return;
		if(res.data.success){
			ingestedrefreshData(1000)
		  toast.success(onSuccessfulQuestionDelete(res.data.message));
  
		}
           ingestedrefreshData(0);
	  })
    setLoading(false)
  };

  return (
    <>
    {/* <Modal
      show={modalState.modalState}
      onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
      centered={true}
      dialogClassName={styles.deleteModal}
      size={"md"}
    >
      <Modal.Header className="modalheader" closeButton closeVariant="white">
        <Modal.Title className="modalTitle">
          <DeleteIcon style={{ padding: "3px", marginBottom: "2px" }} />
          OverWrite Document
        </Modal.Title>
      </Modal.Header>
      <ModalBody className="modalBody">
        <div
          className="d-flex justify-content-center"
          style={{ marginBottom: "20px", marginTop: "20px" }}
        >
          Are you sure, You want to overwrite the older document?
        </div>
        <div
          className="row"
          style={{ marginTop: "12px", marginBottom: "12px" }}
        >
          <div className="col-lg-12 d-flex justify-content-center" style={{fontSize:'13px', color:'grey'}}>
            Document:<span style={{color:'grey', fontWeight:300}}>{IngestedState.tableDataCurrent.title}</span>
          </div>
        </div>
		<div className="mb-2" style={{textAlign:'center'}}>
			<VizButton type={'Primary'} size={2} onClick={onClickDeleteDataConfirm}>Submit</VizButton>
		</div>
      </ModalBody>
    </Modal> */}

    <Modal show={modalState.modalState}
               onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
               centered={true}
               size={"lg"}
               style={{ marginTop: "-50px" }}
           // scrollable={true}
           >
               <Modal.Header closeButton>
                   <Modal.Title style={modalTitleStyle}>
                       <span>
                           <i class="fa fa-trash" aria-hidden="true"> </i> &nbsp;&nbsp;OverWrite Document
                       </span>
    
    
                   </Modal.Title>
               </Modal.Header>
               <ModalBody>
                   {/* <div className="row" style={{ paddingLeft: '3.0rem', paddingRight: '3.0rem', paddingBottom: '5px', textAlign: 'center' }}>
                       <div className="container">
                           <p style={{ fontSize: '16px', fontWeight: '300' }}>Are you sure you want to Delete this Answer?</p>
                           <p style={{ fontSize: '14px', fontWeight: '300' }}>The Seeker will no longer be able to view this answer</p>
    
    
                           {!isLoading && <div>
                               <button className="cancelBtn" onClick={() => advanceFilterModalToggle({ bool: false, value: "" })}>No</button>&nbsp;<button className="rerouteBtn" onClick={() => onClickButtons()}>Yes</button>
                           </div>}
                           {isLoading &&
                               <div>
                                   <button className="loadingpublishbutton" disabled><i className="fa fa-spinner"></i>&nbsp;&nbsp;Deleting...</button>
                               </div>}
                       </div>
                   </div> */}
    
    
                   <div className="row" style={{ paddingLeft: '3.0rem', paddingRight: '3.0rem', paddingBottom: '5px', textAlign: 'center' }}>
                       <div className="container">
                           <div style={{ width: "100%", justifyContent: "center" }}>
                               <p style={textStyles1}> Are you sure, You want to overwrite the older document?</p>
                               {/* <p style={textStyles1}>And the Seeker will no longer be able to view this question.</p> */}
                             <span style={textStyles1}>Document:{IngestedState.tableDataCurrent.title}</span>
                           </div>
    
    
    
    
                           {!isLoading && <div style={{marginTop:"2px"}}>
                             <button
                                   style={{
                                       padding: '8px 12px 8px 12px',
                                       borderRadius: '6px',
                                       fontSize: '14px',
                                       lineHeight: '24px',
                                       fontWeight: 400,
                                       boxShadow: '0px 1px 2px 0px #1018280D',
                                       color: '#FFFFFF',
                                       border: '1px solid  #fff',
                                       height: '40px',
                                       minWidth: '88px',
                                       background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                                       marginBottom: '14px',
                                       cursor: "pointer"
                                   }}
                                   onClick={() => onClickDeleteDataConfirm()}>Yes</button>
                           </div>}
                           {isLoading &&
                               <div>
                                   <button
                                       style={{
                                           padding: '8px 12px 8px 12px',
                                           borderRadius: '6px',
                                           fontSize: '14px',
                                           lineHeight: '24px',
                                           fontWeight: 400,
                                           boxShadow: '0px 1px 2px 0px #1018280D',
                                           color: '#FFFFFF',
                                           border: '1px solid  #fff',
                                           height: '40px',
                                           minWidth: '88px',
                                           background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                                           marginBottom: '14px',
                                           cursor: "not-allowed",
                                           opacity:"0.7"
                                       }}
                                       disabled><i className="fa fa-spinner"></i>&nbsp;&nbsp;Deleting</button>
                               </div>}
                       </div>
                   </div>
               </ModalBody>
           </Modal>
    </>
  );
}
